"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BOARD_COLORS = exports._BOARD_COLORS_NAMES = exports.LAYER_COLORS = exports.COLOR_NAME = exports.LIGHT_COLORS = exports.colorHash = void 0;
// fonts live in helpers/tools_to_build_newstroke-font/README.md
// taken mostly from colors.cpp and color_settings.cpp
const sdbm_1 = __importDefault(require("sdbm"));
function colorHash(x) {
    return "#" + decimalToHex(sdbm_1.default(x) % 0x1000000, 6);
}
exports.colorHash = colorHash;
function decimalToHex(d, padding) {
    var hex = Number(d).toString(16);
    padding =
        typeof padding === "undefined" || padding === null
            ? (padding = 2)
            : padding;
    while (hex.length < padding) {
        hex = "0" + hex;
    }
    return hex;
}
/*
function decimalToHex(d, padding) {
    var hex = Number(d).toString(16);
    padding =
        typeof padding === "undefined" || padding === null
            ? (padding = 2)
            : padding;
    while (hex.length < padding) {
        hex = "0" + hex;
    }
    return hex;
}

const raw_colors = {
    BLACK: [0, 0, 0],
    DARKDARKGRAY: [72, 72, 72],
    DARKGRAY: [132, 132, 132],
    LIGHTGRAY: [194, 194, 194],
    WHITE: [255, 255, 255],
    LIGHTYELLOW: [194, 255, 255],
    DARKBLUE: [72, 0, 0],
    DARKGREEN: [0, 72, 0],
    DARKCYAN: [72, 72, 0],
    DARKRED: [0, 0, 72],
    DARKMAGENTA: [72, 0, 72],
    DARKBROWN: [0, 72, 72],
    BLUE: [132, 0, 0],
    GREEN: [0, 132, 0],
    CYAN: [132, 132, 0],
    RED: [0, 0, 132],
    MAGENTA: [132, 0, 132],
    BROWN: [0, 132, 132],
    LIGHTBLUE: [194, 0, 0],
    LIGHTGREEN: [0, 194, 0],
    LIGHTCYAN: [194, 194, 0],
    LIGHTRED: [0, 0, 194],
    LIGHTMAGENTA: [194, 0, 194],
    YELLOW: [0, 194, 194],
    PUREBLUE: [255, 0, 0],
    PUREGREEN: [0, 255, 0],
    PURECYAN: [255, 255, 0],
    PURERED: [0, 0, 255],
    PUREMAGENTA: [255, 0, 255],
    PUREYELLOW: [0, 255, 255],
};

Object.fromEntries(
    Object.entries(raw_colors)
        .map((pair) => [pair[0], pair[1].map((x) => decimalToHex(x, 2))])
        .map((pair) => [pair[0], `#${pair[1][2]}${pair[1][1]}${pair[1][0]}`])
);

*/
exports.LIGHT_COLORS = {
    BLACK: "DARKDARKGRAY",
    DARKDARKGRAY: "DARKGRAY",
    DARKGRAY: "LIGHTGRAY",
    LIGHTGRAY: "WHITE",
    WHITE: "WHITE",
    LIGHTYELLOW: "WHITE",
    DARKBLUE: "BLUE",
    DARKGREEN: "GREEN",
    DARKCYAN: "CYAN",
    DARKRED: "RED",
    DARKMAGENTA: "MAGENTA",
    DARKBROWN: "BROWN",
    BLUE: "LIGHTBLUE",
    GREEN: "LIGHTGREEN",
    CYAN: "LIGHTCYAN",
    RED: "LIGHTRED",
    MAGENTA: "LIGHTMAGENTA",
    BROWN: "YELLOW",
    LIGHTBLUE: "PUREBLUE",
    LIGHTGREEN: "PUREGREEN",
    LIGHTCYAN: "PURECYAN",
    LIGHTRED: "PURERED",
    LIGHTMAGENTA: "PUREMAGENTA",
    YELLOW: "PUREYELLOW",
    PUREBLUE: "WHITE",
    PUREGREEN: "WHITE",
    PURECYAN: "WHITE",
    PURERED: "WHITE",
    PUREMAGENTA: "WHITE",
    PUREYELLOW: "WHITE",
};
exports.COLOR_NAME = {
    BLACK: "Black",
    DARKDARKGRAY: "Gray 1",
    DARKGRAY: "Gray 2",
    LIGHTGRAY: "Gray 3",
    WHITE: "White",
    LIGHTYELLOW: "L.Yellow",
    DARKBLUE: "Blue 1",
    DARKGREEN: "Green 1",
    DARKCYAN: "Cyan 1",
    DARKRED: "Red 1",
    DARKMAGENTA: "Magenta 1",
    DARKBROWN: "Brown 1",
    BLUE: "Blue 2",
    GREEN: "Green 2",
    CYAN: "Cyan 2",
    RED: "Red 2",
    MAGENTA: "Magenta 2",
    BROWN: "Brown 2",
    LIGHTBLUE: "Blue 3",
    LIGHTGREEN: "Green 3",
    LIGHTCYAN: "Cyan 3",
    LIGHTRED: "Red 3",
    LIGHTMAGENTA: "Magenta 3",
    YELLOW: "Yellow 3",
    PUREBLUE: "Blue 4",
    PUREGREEN: "Green 4",
    PURECYAN: "Cyan 4",
    PURERED: "Red 4",
    PUREMAGENTA: "Magenta 4",
    PUREYELLOW: "Yellow 4",
};
const colors = {
    BLACK: "#000000",
    DARKDARKGRAY: "#484848",
    DARKGRAY: "#848484",
    LIGHTGRAY: "#c2c2c2",
    WHITE: "#ffffff",
    LIGHTYELLOW: "#ffffc2",
    DARKBLUE: "#000048",
    DARKGREEN: "#004800",
    DARKCYAN: "#004848",
    DARKRED: "#480000",
    DARKMAGENTA: "#480048",
    DARKBROWN: "#484800",
    BLUE: "#000084",
    GREEN: "#008400",
    CYAN: "#008484",
    RED: "#840000",
    MAGENTA: "#840084",
    BROWN: "#848400",
    LIGHTBLUE: "#0000c2",
    LIGHTGREEN: "#00c200",
    LIGHTCYAN: "#00c2c2",
    LIGHTRED: "#c20000",
    LIGHTMAGENTA: "#c200c2",
    YELLOW: "#c2c200",
    PUREBLUE: "#0000ff",
    PUREGREEN: "#00ff00",
    PURECYAN: "#00ffff",
    PURERED: "#ff0000",
    PUREMAGENTA: "#ff00ff",
    PUREYELLOW: "#ffff00",
};
exports.LAYER_COLORS = {
    ANCHOR: "BLUE",
    "AUX.ITEMS": "WHITE",
    "PCB.BACKGROUND": "BLACK",
    CURSOR: "WHITE",
    "DRC.ERROR": "PURERED",
    "DRC.WARNING": "PUREYELLOW",
    "MOD.TEXT.BK": "BLUE",
    "MOD.TEXT.FR": "LIGHTGRAY",
    "MOD.TEXT.INVISIBLE": "LIGHTGRAY",
    GRID: "DARKGRAY",
    "GRID.AXES": "LIGHTGRAY",
    "NO.CONNECTS": "BLUE",
    "PAD.BK": "GREEN",
    "PAD.FR": "RED",
    "PADS.PLATEDHOLES": "YELLOW",
    "PADS.TH": "YELLOW",
    "NON.PLATEDHOLES": "YELLOW",
    RATSNEST: "WHITE",
    "SELECT.OVERLAY": "DARKRED",
    VIAS: "BLACK",
    "VIA.BBLIND": "BROWN",
    "VIAS.HOLES": "WHITE",
    "VIA.MICROVIA": "CYAN",
    "VIA.THROUGH": "LIGHTGRAY",
    WORKSHEET: "DARKRED",
};
exports._BOARD_COLORS_NAMES = {
    "F.Cu": "RED",
    "In1.Cu": "YELLOW",
    "In2.Cu": "LIGHTMAGENTA",
    "In3.Cu": "LIGHTRED",
    "In4.Cu": "CYAN",
    "In5.Cu": "GREEN",
    "In6.Cu": "BLUE",
    "In7.Cu": "DARKGRAY",
    "In8.Cu": "MAGENTA",
    "In9.Cu": "LIGHTGRAY",
    "In10.Cu": "MAGENTA",
    "In11.Cu": "RED",
    "In12.Cu": "BROWN",
    "In13.Cu": "LIGHTGRAY",
    "In14.Cu": "BLUE",
    "In15.Cu": "GREEN",
    "In16.Cu": "RED",
    "In17.Cu": "YELLOW",
    "In18.Cu": "LIGHTMAGENTA",
    "In19.Cu": "LIGHTRED",
    "In20.Cu": "CYAN",
    "In21.Cu": "GREEN",
    "In22.Cu": "BLUE",
    "In23.Cu": "DARKGRAY",
    "In24.Cu": "MAGENTA",
    "In25.Cu": "LIGHTGRAY",
    "In26.Cu": "MAGENTA",
    "In27.Cu": "RED",
    "In28.Cu": "BROWN",
    "In29.Cu": "LIGHTGRAY",
    "In30.Cu": "BLUE",
    "B.Cu": "GREEN",
    "B.Adhes": "BLUE",
    "F.Adhes": "MAGENTA",
    "B.Paste": "LIGHTCYAN",
    "F.Paste": "RED",
    "B.SilkS": "MAGENTA",
    "F.SilkS": "CYAN",
    "B.Mask": "BROWN",
    "F.Mask": "MAGENTA",
    "Dwgs.User": "LIGHTGRAY",
    "Cmts.User": "BLUE",
    "Eco1.User": "GREEN",
    "Eco2.User": "YELLOW",
    "Edge.Cuts": "YELLOW",
    Margin: "LIGHTMAGENTA",
    "B.CrtYd": "DARKGRAY",
    "F.CrtYd": "LIGHTGRAY",
    "B.Fab": "BLUE",
    "F.Fab": "DARKGRAY",
};
const _BOARD_COLORS = Object.fromEntries(Object.entries(exports._BOARD_COLORS_NAMES).map((pair) => [
    pair[0],
    colors[pair[1]],
]));
exports.BOARD_COLORS = new Proxy(_BOARD_COLORS, {
    get: (target, prop, receiver) => {
        if (prop === "$$typeof")
            return Reflect.get(target, prop, receiver);
        if (!(prop in target)) {
            alert("color prop: '" + prop + "'");
            target[prop] = colorHash(prop);
        }
        return Reflect.get(target, prop, receiver);
    },
});
